import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmpresaRoutingModule } from './empresa-routing.module';
import { MeuPlanoComponent } from './pages/meu-plano/meu-plano.component';
import { FinanceiroComponent } from './pages/financeiro/financeiro.component';
import { CadastrarComponent } from './pages/cadastrar/cadastrar.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxMaskDirective} from "ngx-mask";


@NgModule({
  declarations: [
    MeuPlanoComponent,
    FinanceiroComponent,
    CadastrarComponent
  ],
    exports: [
        MeuPlanoComponent
    ],
    imports: [
        CommonModule,
        EmpresaRoutingModule,
        ComponentesModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective
    ]
})
export class EmpresaModule { }
